import R from '../../../core-res/R';
export default function getContainerStyle(variant, disabled, containerBorderColor, containerBorderWidth, theme) {
    let containerStyle = {};
    if (variant === 'MINIMAL') {
        containerStyle = {
            backgroundColor: disabled ? theme.lightNeutral : 'transparent',
            borderBottomColor: containerBorderColor,
            borderBottomWidth: containerBorderWidth,
        };
    }
    else {
        containerStyle = {
            backgroundColor: theme.lightPrimary,
            borderColor: containerBorderColor,
            borderWidth: containerBorderWidth,
            borderRadius: R.border.radius.default,
            padding: R.spacing.xs - R.border.width.thin,
        };
    }
    return containerStyle;
}
